import { api } from '@/lib/api'
import type { AdminUser } from '@/types/admin'

/**
 * What is left of the auth API once Firebase owns credentials.
 *
 * There is no login, refresh or logout call: the browser authenticates directly with
 * Firebase, the SDK renews tokens in the background, and signing out is a local Firebase
 * operation. This endpoint answers the one question Firebase cannot — what this person is
 * allowed to do in this store.
 */
export function getMe(options?: {
  redirectOnAuthFailure?: boolean
  signal?: AbortSignal
}): Promise<AdminUser> {
  return api.get<AdminUser>('/admin/auth/me', options)
}
